import React from 'react';

const ShareIcon = () => {
  return (
    <svg
      width='12'
      height='15'
      viewBox='0 0 12 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.33333 4.59782V5.93116H1.33333V11.9312H10.6667V5.93116H8.66667V4.59782H10.6667C11.0203 4.59782 11.3594 4.7383 11.6095 4.98835C11.8595 5.2384 12 5.57753 12 5.93116V11.9312C12 12.2848 11.8595 12.6239 11.6095 12.874C11.3594 13.124 11.0203 13.2645 10.6667 13.2645H1.33333C0.979711 13.2645 0.640573 13.124 0.390524 12.874C0.140476 12.6239 0 12.2848 0 11.9312V5.93116C0 5.57753 0.140476 5.2384 0.390524 4.98835C0.640573 4.7383 0.979711 4.59782 1.33333 4.59782H3.33333ZM6.58933 0.243822L8.82867 2.48249C8.95376 2.60758 9.02404 2.77725 9.02404 2.95416C9.02404 3.13106 8.95376 3.30073 8.82867 3.42582C8.70357 3.55092 8.53391 3.62119 8.357 3.62119C8.18009 3.62119 8.01043 3.55092 7.88533 3.42582L6.66667 2.20649V8.59782C6.66667 8.77463 6.59643 8.9442 6.4714 9.06923C6.34638 9.19425 6.17681 9.26449 6 9.26449C5.82319 9.26449 5.65362 9.19425 5.5286 9.06923C5.40357 8.9442 5.33333 8.77463 5.33333 8.59782V2.20649L4.11467 3.42582C4.05273 3.48776 3.97919 3.5369 3.89826 3.57042C3.81734 3.60394 3.7306 3.62119 3.643 3.62119C3.5554 3.62119 3.46866 3.60394 3.38774 3.57042C3.30681 3.5369 3.23327 3.48776 3.17133 3.42582C3.10939 3.36388 3.06026 3.29035 3.02674 3.20942C2.99322 3.12849 2.97596 3.04175 2.97596 2.95416C2.97596 2.86656 2.99322 2.77982 3.02674 2.69889C3.06026 2.61796 3.10939 2.54443 3.17133 2.48249L5.41133 0.243822C5.56759 0.0876983 5.77944 0 6.00033 0C6.22122 0 6.43307 0.0876983 6.58933 0.243822Z'
        fill='white'
      />
    </svg>
  );
};

export default ShareIcon;
